<ion-app>
  <!--<ion-split-pane>
    <ion-menu>
      <ion-header>
        <ion-toolbar>
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
            <ion-item [routerDirection]="'root'" [routerLink]="[p.url]">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
      <ion-tabs main>
          <ion-tab-bar slot="bottom">
              <ion-tab-button tab="home">
                  <ion-label>Home</ion-label>
                  <ion-icon name="home"></ion-icon>
                  <ion-badge>6</ion-badge>
              </ion-tab-button>
              <ion-tab-button tab="settings">
                  <ion-label>Settings</ion-label>
                  <ion-icon name="settings"></ion-icon>
              </ion-tab-button>
          </ion-tab-bar>
      </ion-tabs>
  </ion-split-pane>-->
    <ion-router-outlet main> <span *ngIf="showLoader" class="loading"></span></ion-router-outlet>
</ion-app>
